
async function renderWishlist(favoritesValue) {
  const grid = document.getElementById('wishlist-grid');
  const emptyState = document.getElementById('wishlist-empty-state');
  const spinner = document.getElementById('wishlist-spinner');

  if (!grid) return;

  /**
   * @type {{ [x: string]: any; }[]}
   */
  const isFromSharedList = Array.isArray(favoritesValue);

  let favorites = isFromSharedList ? favoritesValue : await getFavorites();

  if (!Array.isArray(favorites) || favorites.filter(o => o.id && o.title).length === 0) {
    grid.style.display = "none";
    if (spinner) spinner.style.display = 'none';
    // @ts-ignore
    emptyState.style.display = 'block';
    return;
  }

  /**
   * @param {{ id: string; title: string; }} product
   */

  const fetchPromises = favorites.map((/** @type {{ title: string; }} */ o) => {
    return fetch(`/search?q=${o.title}`)
      .then(res => res.ok ? res.text() : null)
      .catch(() => null);
  }
  );

  try {
    const rawHTMLs = await Promise.all(fetchPromises);
    const parser = new DOMParser();
    let finalHTML = '';

    rawHTMLs.forEach((htmlString, index) => {
      if (!htmlString) return;

      const doc = parser.parseFromString(htmlString, 'text/html');

      const cardElement = doc.querySelector(`li[data-product-id="${favorites?.[index]?.["id"]}"]`);

      if (isFromSharedList) {
        const favoriteButton = cardElement?.querySelector('.favorite-toggle-btn');
        if (favoriteButton) {
          favoriteButton.style.display = "none";
        }
      }

      if (cardElement) {
        finalHTML += cardElement.outerHTML;
      }
    });

    grid.innerHTML = finalHTML;

    if (spinner) spinner.style.display = 'none';
    if (emptyState) emptyState.style.display = 'none';

    if (typeof updateFavoriteButtons === 'function') {
      updateFavoriteButtons(favoritesValue);
    }

  } catch (error) {
    console.error("Error rendering wishlist:", error);
    grid.innerHTML = '<div class="text-center"><p>Error loading favorites. Please refresh.</p></div>';
  }
}

const SHOPIFY_DOMAIN = "https://honeybadger-9413.myshopify.com"

document.body.addEventListener('click', async (e) => {
  // @ts-ignore
  const btn = e?.target?.closest('.wishlist-share-button');
  if (btn) {
    const favorites = await getFavorites();

    const response = await fetch(`${WORKER_BASE_URL}/share-guest`, {
      method: 'POST',
      body: JSON.stringify({ handles: favorites }),
    });

    const data = await response.json();

    if (data.success) {
      const shareLink = `${SHOPIFY_DOMAIN}/pages/wish-list?share_id=${data.shareId}`;

      if (navigator.share) {
        try {
          await navigator.share({
            // title: '{{ product.title | escape }}',
            // text: 'Check out this curated collection',
            url: shareLink
          });
        } catch (err) {
          console.error('Share failed:', err);
        }
      } else {
        // Fallback for older browsers (e.g., call a copy-to-clipboard function)
        console.log('Web Share API not supported');
      }
    }
  }
});

async function loadSharedWishlist(shareId) {
  try {
    // Fetch the shared array from your Cloudflare KV database
    const response = await fetch(`${WORKER_BASE_URL}/get-shared?shareId=${shareId}`);
    const data = await response.json();

    if (data.success && data.wishlist.length > 0) {
      // Re-use your existing rendering function to draw the bags on the screen!
      // (Assuming you have a function that takes an array of handles and builds the HTML)
      const subtitle = document.querySelector('.wishlist-sub-title');
      if (subtitle) {
        subtitle.textContent = "Discover the pieces selected by your connection";
      }

      renderWishlist(data.wishlist);

      // Optional: Hide the standard "Share" button since they are already viewing a shared list
      const shareBtn = document.getElementById('share-wishlist-btn');
      if (shareBtn) shareBtn.style.display = 'none';
    }
  } catch (error) {
    console.error("Error loading shared wishlist:", error);
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  // 1. Check the URL for the share ID
  const urlParams = new URLSearchParams(window.location.search);
  const shareId = urlParams.get('share_id');

  if (shareId) {
    // 2. The user is viewing a shared list! Trigger Discovery Mode.
    loadSharedWishlist(shareId);
  } else {
    renderWishlist();
  }
});